import { ThemeDefault } from '@seddi/ui-kit';

const color = {
  ...ThemeDefault.color,
  s1: '#B039B2',
  s2: 'rgba(255, 52, 148, 1)',
};

export const themeGradient = `radial-gradient(47.69% 118.91% at 97.69% 96.89%,
  rgba(255, 255, 255, 0.2) 0%,
  rgba(255, 255, 255, 0) 100%),
radial-gradient(23.69% 37.41% at 99.06% 0%,
  rgba(254, 255, 255, 0.6) 0%,
  rgba(255, 255, 255, 0) 100%),
linear-gradient(112.07deg,
  rgba(254, 241, 225, 0.8) -0.19%,
  rgba(227, 48, 112, 0.8) 99.7%),
  #FFFFFF`;

export const theme = {
  ...ThemeDefault,
  background: themeGradient,
  color,
};
